import { Root as BaseRoot } from '@radix-ui/react-tabs'

export const Root = BaseRoot
